import React from "react";
import "./Contact.css";

export default function Contact() {
  return (
    <section className="contact-section">
      <h1>Contact Me</h1>
      <p className="contact-intro">
        I’d love to hear from you! Whether it’s a project idea, collaboration, or just a hello —
        feel free to reach out.
      </p>

      <div className="contact-container">
        <form
          className="contact-form"
          action="https://formspree.io/f/YOUR_FORM_ID"
          method="POST"
        >
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" required placeholder="Your name" />

          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="_replyto" required placeholder="you@example.com" />

          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" rows="5" required placeholder="Your message..." />

          <button type="submit" className="send-btn">Send Message</button>
        </form>

        <div className="contact-info">
          <h3>Let’s Connect</h3>
          <ul>
            <li>📍 Paris, France</li>
            <li>✉️ <a href="mailto:aydayurtoglu@gmail.com">aydayurtoglu@gmail.com</a></li>
            <li>
              <a href="https://linkedin.com/in/aydayurtoglu" target="_blank" rel="noreferrer">LinkedIn</a> •{" "}
              <a href="https://github.com/aydayurtoglu" target="_blank" rel="noreferrer">GitHub</a> •{" "}
              <a href="https://aydayurtoglu.com" target="_blank" rel="noreferrer">Portfolio</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
